import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
import '../css/Footer.css'
import '.././App.css';

class TouchSpin extends React.Component {
    constructor(props) {
        super(props);

        this.state =
        {
            value: this.props.elementvalue
             
        }

        this.onAddClick = this.onAddClick.bind(this);
        this.onMinusClick = this.onMinusClick.bind(this);
        this.sendData = this.sendData.bind(this);


    }

    sendData = () => {
        this.props.parentCallback(this.state.value);
    }

    async onAddClick() {
       
        if(this.state.value <  100 && this.props.Totalpercentage <=99){
        await this.setState(
            {
                value: this.state.value + 1
            }
        )
          this.sendData();
        }
    }



    async onMinusClick(){
      
      if(this.state.value > 0){
       await this.setState(
            {   
            value: this.state.value - 1
            }
        )
        this.sendData();
      }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({value: nextProps.elementvalue}) 
      }


render() {
    return (
        
        <Card style={{ width: '15%', marginRight:'1.5%' }} className="card border text-center align-items-center">
            <Card.Title className="card-header text-center align-items-center">

            </Card.Title>
            <Card.Body>
                <div classname="card-title "><p class="myfont-weight-bold">{this.props.Title}<br></br>Points</p></div>
                <br></br>
                <div className="text-center" id="example-caption-3">{this.state.value} Points</div>
                <div className="progress progress-bar-shell">
                    <div className="progress-bar" role="progressbar" aria-valuenow={25} aria-valuemin={25} aria-valuemax={100} style={{ width: this.state.value +'%' }} aria-describedby="example-caption-3" />
                </div>
                <span class="input-group-btn input-group-prepend bootstrap-touchspin-injected">
                    <button class="btn btn-shell-grey mybutton" type="button" onClick={this.onMinusClick}>-</button>
                    <input type="number" className="touchspin  form-control myform-control" value={this.state.value} defaultValue={this.state.value}></input>
                    <button class="btn btn-shell-grey mybutton" type="button" onClick={this.onAddClick}>+</button>
                </span>
            </Card.Body>
        </Card>
         

    );

}

}


export default TouchSpin;